module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate-new/ig-images/ig-05-93f46fbf4ecc20c650aeaabe15835430.jpg";